var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.65 5.483a13.654 13.654 0 0 0-6.293 2.88c-.584.477-.58 1.347-.046 1.88.467.468 1.187.52 1.758.213.08-.043.157-.093.23-.15A10.973 10.973 0 0 1 7.82 8.841a10.924 10.924 0 0 1 1.83-.575zm4.552 2.75a10.923 10.923 0 0 1 4.5 2.073c.073.057.15.107.23.15.572.307 1.29.255 1.758-.212.534-.534.538-1.404-.046-1.882a13.448 13.448 0 0 0-.954-.713 13.65 13.65 0 0 0-5.488-2.192zM12 3.682a1 1 0 0 0-1 1v10a1 1 0 1 0 2 0v-10a1 1 0 0 0-1-1M12 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.726 10.156A9.097 9.097 0 0 0 6.6 11.643c-.607.448-.602 1.322-.069 1.856.435.434 1.085.505 1.655.295.13-.047.254-.11.372-.185a6.38 6.38 0 0 1 1.17-.591zm4.552 2.862a6.423 6.423 0 0 1 1.168.591c.118.076.243.138.372.185.57.21 1.22.14 1.655-.295.533-.534.538-1.408-.069-1.856a9.125 9.125 0 0 0-3.126-1.487z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/NoConnection.8a5d46d3f2dc4bd424c273b0229ed775.svg";
export { ForwardRef as ReactComponent };